import { useEffect, useState } from 'react';

interface Props {
  onlineCallback: () => void;
  offlineCallback: () => void;
}

const useNetworkStatus = ({ onlineCallback, offlineCallback }: Props) => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    if (RUNTIME_ENV === 'native') {
      return;
    }
    // Update network status
    const handleStatusChange = () => {
      if (navigator.onLine) {
        onlineCallback();
      }
      if (!navigator.onLine) {
        offlineCallback();
      }
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleStatusChange);
    window.addEventListener('offline', handleStatusChange);

    // Cleanup
    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, [isOnline]);
};

export default useNetworkStatus;
